store.admin.order = {};
store.admin.order.initEdit = function() {
	var $form = $('#store').find('form.store_form');
	var paidId = parseInt($form.data('paid-id'));
	var sendReceiptId = parseInt($form.data('send-receipt'));
	var sendStatusId = parseInt($form.data('send-status'));
	var $statusElements = $form.find('select.watchChange');
	var $emailFieldset = $form.find('#fieldset-email');
	var $sendEmail = $form.find('#sendEmail');
	var $needsChange = $form.find('.needsChange');
	var $receiptOption = $sendEmail.find('option[value=' + sendReceiptId + ']');
	var $billingStatus = $statusElements.filter('#billingStatus');

	var checkChange = function() {
		var ret = false;
		$statusElements.each(function() {
			var $this = $(this);
			if ($this.data('initialValue') !== $this.val()) {
				ret = true;
			}
		});
		return ret;
	};

	var checkPaid = function() {
		if (!changedToPaid()) {
			$receiptOption.addClass('hide');
			if (parseInt($sendEmail.val()) === sendReceiptId) {
				$sendEmail.val('');
			}
		}
		else {
			$receiptOption.removeClass('hide');
		}
	};

	var changedToPaid = function() {
		var val = $billingStatus.val();
		return (parseInt(val) === paidId && val !== $billingStatus.data('initialValue'));
	};

	$statusElements.change(function() {
		if (checkChange()) {
			$needsChange.removeClass('hide');
			checkPaid();
		}
		else {
			$needsChange.addClass('hide');
			$emailFieldset.addClass('hide');
			$sendEmail.val('');
		}
	});

	$sendEmail.change(function() {
		var val = parseInt($(this).val());
		if (val === sendStatusId) {
			$emailFieldset.removeClass('hide');
		}
		else {
			$emailFieldset.addClass('hide');
		}
	});
};
